export const NAVIGATION_IDS = {
	HOW_TO_PLAY: 'how-to-play',
	CELL_DISTRIBUTION_BY_ROW: 'cell-distribution-by-row',
	STOP_AND_WINNING: 'stop-and-winning',
	PLACING_BETS: 'placing-bets',
	FAST_BETS_AND_X2_TOGGLE: 'fast-bets-and-x2-toggle',
	BET_CALCULATOR: 'bet-calculator',
	MUSIC_AND_SOUNDS: 'music-and-sounds',
	RTP: 'rtp',
	DISCONNECTION_POLICY: 'disconnection-policy',
} as const satisfies Record<string, string>;

export type NavigationIds = (typeof NAVIGATION_IDS)[keyof typeof NAVIGATION_IDS];
